// @core/api/endpoints/secret/get_engine.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SecretEngineResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get secrets engine
 * Returns details of a mounted secrets engine including type, configuration, and status.
 */
export async function GetEngine(
  engine_id: string,
  options?: RequestOptions
): Promise<SecretEngineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.get<SecretEngineResponse>(requestPath, { ...requestOptions });
}
